<template>
  <div class="warrants-wrapper rk-section">
    <WarrantList :total="20" />
    <div class="show-more" @click="changeRouter">{{ $t('查看更多') }} <i class="iconfont icon-xiangxia"></i></div>
  </div>
</template>

<script>
import WarrantList from '@/components/warrants/WarrantList.vue'
export default {
  components: { WarrantList },
  methods: {
    changeRouter() {
      this.$router.push({
        path: '/warrants/details',
        query: {
          symbol: this.$route.query.symbol
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.warrants-wrapper {
  padding: 0 15px;
  background: var(--bg-color-2);
  .show-more {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    font-size: 14px;
    color: var(--font-color-3);
    .iconfont {
      font-size: 14px;
      margin-left: 8px;
    }
  }
}
</style>
